import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CloseIcon from "@mui/icons-material/Close";
import { Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
function Home({ showSuccess, setSelectedUser }) {
  const navigate = useNavigate();
  const [user, setUser] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const location = useLocation();
  const { currentUser } = location.state || {};

  useEffect(() => {
    setUser(currentUser);
  }, [currentUser]);

  const handleClick = async () => {
    if (!user) {
      // If no user is selected, open the modal
      setOpenModal(true);
    } else {
      setSelectedUser(user);
      // If a user is selected, navigate to the "/form" route
      navigate("/form");
    }
  };

  const handleCloseModal = () => {
    // Close the modal
    setOpenModal(false);
  };

  const isMobile = () => {
    // Check if the viewport width is below a certain threshold
    return window.innerWidth <= 370; // Adjust the threshold based on your needs
  };

  return (
    <div className="App">
      {showSuccess && (
        <p className="success-banner">🎉 Successfully Submitted</p>
      )}
      <div className="user-select">
        <select
          name=""
          id=""
          value={user}
          onChange={(e) => setUser(e.target.value)}
        >
          <option
            value=""
            style={{ display: "none", color: "gray", opacity: 1 }}
          >
            User
          </option>
          <option value="Jacklyn">Jacklyn</option>
          <option value="Tester">Tester</option>
        </select>
      </div>
      <button className="redBtn" onClick={handleClick}>
        Report Contamination
      </button>

      {/* Modal for user not selected */}
      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogContent>
          <div className="modal-div">
            <CloseIcon className="close-icon" onClick={handleCloseModal} />
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 7,
                justifyContent: "center",
                alignItems: "center",
              }}
              className="nested-div-modal"
            >
              <ReportProblemIcon style={{ color: "white", fontSize: "28px" }} />
              <Typography
                variant="h6"
                component="h6"
                style={{ marginTop: "3px" }}
              >
                Missing Info!
              </Typography>
            </div>
            <div style={isMobile() ? {} : { padding: "0 0 0 6px" }}>
              <p
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: isMobile() ? "14.2px" : "16px",
                }}
              >
                Select your name from the user list
              </p>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default Home;
